import { createContext } from "react";
import { StoreApi } from "zustand";

import { ManageRolesStoreType } from "./manage_roles_store.types";

type ManageRolesStoreContextType = StoreApi<ManageRolesStoreType>;

export const ManageRolesStoreContext = createContext<ManageRolesStoreContextType>(
  {} as ManageRolesStoreContextType
);
